module.exports = {
    publicPath: "/"
}